import Components from "../components";

// This component selects a bootstrap tab based on the URL's hash.
// It does not update the URL when the user selects a tab because that
// breaks turbo.
//
// A tab can declare data-hash-aliases (space-separated list of hashes,
// e.g. data-hash-aliases="#authentication") to also match previously
// published anchors that have since been renamed — old deep links keep
// landing on the right tab.
class NavStateful extends Components.Base {
  initialize() {
    const hash = window.location.hash;
    if (!hash) return;

    const link = this.$el.find(`a[href="${hash}"]`);
    if (link.length > 0) {
      link.tab("show");
    } else {
      this.$el.find(`a[data-hash-aliases~="${hash}"]`).first().tab("show");
    }
  }
}

Components.collection.register({
  selector: ".c-nav-stateful",
  klass: NavStateful,
});
